import { getButtonThemeColors as getSharedButtonThemeColors } from '@focuslee/shared-mini-app';
import type { RGB } from '@tma.js/types';

export const getButtonThemeColors = (isEnabled: boolean = true) => {
    if (!isEnabled) return getSharedButtonThemeColors(false);

    return {
        backgroundColor: 'var(--tg-theme-button-color)' as RGB,
        textColor: 'var(--tg-theme-button-text-color)' as RGB,
    };
};

export type { ThemeColors } from '@focuslee/shared-mini-app';
